// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\projects\project.hooks.js

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ProjectService } from './project.service';

export const useGetDefaultDeliveryAddress = (customerId) => {
  return useQuery({
    queryKey: ['defaultDeliveryAddress', customerId],
    queryFn: async () => {
      const response = await ProjectService.getDefaultDeliveryAddress(customerId);
      return response?.data || response;
    },
    enabled: !!customerId,
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};

export const useGetProjectsByCustomer = (customerId) => {
  return useQuery({
    queryKey: ['projects', customerId],
    queryFn: async () => {
      const response = await ProjectService.getProjectsByCustomer(customerId);
      return response?.data || response;
    },
    enabled: !!customerId,
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};

export const useSelectDeliveryAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => ProjectService.selectDeliveryAddressForCustomer(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['defaultDeliveryAddress', variables.customer_id],
      });
      queryClient.invalidateQueries({ queryKey: ['deliveryAddresses'] });
    },
  });
};